var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMonitor(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 32,
    width: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cy: 16,
    cx: 16,
    fill: "#FFF",
    r: 16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 21.38h18v1.895H7zm5.24-1.978h7.52v1.211h-7.52zM8.25 9.81v8.603h15.5V9.81zM7.118 8.725h17.764v10.593H7.118z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitor);
export default ForwardRef;